import {setAmplitudeUserProperties} from "@pg-mono/amplitude";

export const setAmplitudePhoneVerifiedUserProperty = (phoneVerified: boolean) => {
    setAmplitudeUserProperties({phone_verified: phoneVerified});
};
import {setAmplitudeUserProperties} from "@pg-mono/amplitude";

export const setAmplitudePhoneVerifiedUserProperty = (phoneVerified: boolean) => {
    setAmplitudeUserProperties({phone_verified: phoneVerified});
};
